export default __webpack_public_path__ + "meetingroomdetails1.json";